import { render } from "./SignWrapSessionView.vue?vue&type=template&id=ec2c889c&scoped=true"
import script from "./SignWrapSessionView.vue?vue&type=script&lang=js"
export * from "./SignWrapSessionView.vue?vue&type=script&lang=js"

import "./SignWrapSessionView.vue?vue&type=style&index=0&id=ec2c889c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2c889c"]])

export default __exports__